// Days a ready-for-pickup load is held before it is cancelled. Mirrors the
// server's lib/pickupDeadline.ts (which drives the ready-for-pickup email).
export const PICKUP_GRACE_DAYS = 7;

// mm/dd/yyyy of the pickup deadline (pickup date + grace days), computed in UTC
// to match how the app renders date-only values. '' for a missing/invalid date.
export function formatPickupDeadline(value: string | null | undefined): string {
  if (!value) return '';

  const [year, month, day] = value.slice(0, 10).split('-').map(Number);
  if (!year || !month || !day) return '';

  const deadline = new Date(Date.UTC(year, month - 1, day));
  deadline.setUTCDate(deadline.getUTCDate() + PICKUP_GRACE_DAYS);

  const mm = String(deadline.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(deadline.getUTCDate()).padStart(2, '0');
  return `${mm}/${dd}/${deadline.getUTCFullYear()}`;
}
